import { Component } from "@angular/core";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { SidebarButtonRouteComponent } from "./sidebar-button-route.component";

@Component({
    selector: "sidebar-stats",
    imports: [],
    templateUrl: "./sidebar-button-route.component.html"
})
export class SidebarStatsButtonComponent extends SidebarButtonRouteComponent {
    public constructor() { 
        super("Stats", SvgIcon.Stats, "stats", false); 
    }
}